// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .callidus-required-err{
            margin: 0;
            padding: 0.6rem;
            margin-top: 3.05rem;
            color: #d0021b;
            border-radius: 3px;
            background-color: #fdf3f4;
            border: solid 1px #d0021b;
            text-align: center;
          }
        `, "",{"version":3,"sources":["webpack://./src/app/shared/warning-message.component.ts"],"names":[],"mappings":"CAAC;YACW,SAAS;YACT,eAAe;YACf,mBAAmB;YACnB,cAAc;YACd,kBAAkB;YAClB,yBAAyB;YACzB,yBAAyB;YACzB,kBAAkB;UACpB","sourcesContent":[" .callidus-required-err{\n            margin: 0;\n            padding: 0.6rem;\n            margin-top: 3.05rem;\n            color: #d0021b;\n            border-radius: 3px;\n            background-color: #fdf3f4;\n            border: solid 1px #d0021b;\n            text-align: center;\n          }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
